var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutpostBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 712.55,
    height: 520.656,
    viewBox: "0 0 712.55 520.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    width: 712.55,
    height: 520.656,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_Assets-08",
    "data-name": "Website Assets-08",
    transform: "translate(213.27 425.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14495",
    "data-name": "Group 14495",
    transform: "translate(-213.27 -425.03)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20870",
    "data-name": "Path 20870",
    d: "M536.8,226.76a4.377,4.377,0,0,1-6.438,1.116l-18.05-14.252a15.631,15.631,0,0,0-14.345-3.049c-3.756,1.077-6.638,3.747-9.048,6.864-14.861,19.234-23.164,59.187-18.408,91.161a134.925,134.925,0,0,0,18.382,50.858,129.48,129.48,0,0,0,38.919,40.49,131.424,131.424,0,0,0,45.8,19.225,135.6,135.6,0,0,0,65.553-2.227,123.555,123.555,0,0,0,66.209-45.676c18.139-24.667,27.784-55.606,27.124-87.12-.677-32.86-12.693-63.254-33.822-85.587a96.36,96.36,0,0,0-11.45-10.347c-10.645-8.141-22.1-13.2-33.907-15h0c-67.955-14.971-106.7,37.905-116.522,53.541",
    transform: "translate(-178.582 83.036)",
    fill: "#e5dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20871",
    "data-name": "Path 20871",
    d: "M409.244,334.281a2.793,2.793,0,0,0,4.335.852l12.91-10.385a10.345,10.345,0,0,1,9.9-2.163c2.512.818,4.36,2.8,5.863,5.11,9.287,14.256,13.2,43.735,8.576,67.244A109.819,109.819,0,0,1,436.1,432.272a99.638,99.638,0,0,1-28.261,29.581,90.989,90.989,0,0,1-32.016,13.886,85.669,85.669,0,0,1-33.145.818,82.524,82.524,0,0,1-11.4-2.819,78.74,78.74,0,0,1-43.1-34.039c-11.258-18.3-16.5-41.137-14.665-64.344,1.886-24.194,11.39-46.5,26.749-62.824a72.856,72.856,0,0,1,8.227-7.575c7.588-5.931,15.619-9.576,23.743-10.841h0c46.928-10.594,71.02,28.576,77.016,40.154",
    transform: "translate(-66.031 13.135)",
    fill: "#38c9bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20872",
    "data-name": "Path 20872",
    d: "M1067.163,279.342a3.081,3.081,0,0,1-3.577-3.538l1.976-19.519a11.669,11.669,0,0,0-4.152-10.947c-2.385-1.827-5.484-2.21-8.691-2.044-19.774,1.043-51.012,17.765-71.025,38.5a139.608,139.608,0,0,0-27.132,39.966,123.005,123.005,0,0,0-11,47.486,105.6,105.6,0,0,0,6.685,40.171,93.885,93.885,0,0,0,20.179,32.148,88.954,88.954,0,0,0,9.955,8.916c17.152,13.162,38.054,19.2,60.465,17.458,24.957-1.925,50.548-12.8,72.038-30.637,22.415-18.6,38.178-43.143,44.395-69.126a88.913,88.913,0,0,0,2.167-13.111c.992-11.356-.524-21.542-4.424-30.164-19.315-52.106-72.753-47.891-87.84-45.561",
    transform: "translate(-450.947 41.304)",
    fill: "#ff2b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20873",
    "data-name": "Path 20873",
    d: "M894.654,464.228H870l5.054-104.114a2.167,2.167,0,1,1,4.326.217l-4.833,99.49h15.576l-4.411-99.507a2.163,2.163,0,0,1,4.322-.2Z",
    transform: "translate(-408.736 -24.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20874",
    "data-name": "Path 20874",
    d: "M870.38,303.5a3.3,3.3,0,0,0-1.094.213c-.426.153-1.013,1.116-.928,2.687a7.737,7.737,0,0,0,2.21,4.8,9.2,9.2,0,0,0,1.989-5.11,2.389,2.389,0,0,0-1.231-2.35,2.006,2.006,0,0,0-.945-.23m.2-16.385a16.432,16.432,0,0,0-11.714,4.884,17.033,17.033,0,0,0-4.99,12.114,17.22,17.22,0,0,0,2.389,8.772,5.7,5.7,0,0,0,5.842,2.674,17.457,17.457,0,0,0,5.037-1.652,12.126,12.126,0,0,1-3.113-7.277c-.183-3.355,1.346-6.2,3.807-7.09a6.685,6.685,0,0,1,5.416.221,6.855,6.855,0,0,1,3.611,6.681,13.758,13.758,0,0,1-2.763,7.32,19.617,19.617,0,0,0,4.36,1.541,6.132,6.132,0,0,0,6.736-2.959,17.288,17.288,0,0,0,2.082-8.746,17.028,17.028,0,0,0-16.423-16.5h-.256m-9.436,32.945a9.792,9.792,0,0,1-3.151-.515,10.011,10.011,0,0,1-5.433-4.373,21.669,21.669,0,0,1-3.036-11.041,21.448,21.448,0,0,1,6.285-15.265,20.681,20.681,0,0,1,14.746-6.149h.349a20.711,20.711,0,0,1,14.414,6.187,21.473,21.473,0,0,1,6.268,14.592,21.784,21.784,0,0,1-2.623,11.011,10.437,10.437,0,0,1-4.995,4.526,10.292,10.292,0,0,1-6.506.588,22.6,22.6,0,0,1-6.757-2.717,20.438,20.438,0,0,1-7.886,2.981,9.792,9.792,0,0,1-1.7.145",
    transform: "translate(-396.993 18.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20875",
    "data-name": "Path 20875",
    d: "M896.06,91.509A2.184,2.184,0,0,1,893.9,89.3V65.718a2.163,2.163,0,1,1,4.292,0v23.59a2.184,2.184,0,0,1-2.163,2.206",
    transform: "translate(-422.447 144.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20876",
    "data-name": "Path 20876",
    d: "M882.313,151.488a2.18,2.18,0,0,1-2.163-2.2V119.22h16.015v29.858a2.167,2.167,0,1,1-4.331,0V123.627h-7.358V149.3a2.18,2.18,0,0,1-2.163,2.2",
    transform: "translate(-414.564 112.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20877",
    "data-name": "Path 20877",
    d: "M884.174,183.529a6.387,6.387,0,1,0,6.281,6.387,6.387,6.387,0,0,0-6.281-6.387m0,17.2a10.8,10.8,0,1,1,10.611-10.8,10.8,10.8,0,0,1-10.611,10.8",
    transform: "translate(-410.561 78.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20878",
    "data-name": "Path 20878",
    d: "M910.376,247.837a2.184,2.184,0,0,1-2.163-2.129l-.894-29.168a2.164,2.164,0,0,1,4.326-.136l.9,29.168a2.193,2.193,0,0,1-2.1,2.274h-.068",
    transform: "translate(-430.163 57.927)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20879",
    "data-name": "Path 20879",
    d: "M880.481,249.013h-.068a2.184,2.184,0,0,1-2.095-2.27l.932-30.394a2.184,2.184,0,0,1,2.163-2.129h.068a2.184,2.184,0,0,1,2.095,2.27l-.932,30.394a2.189,2.189,0,0,1-2.163,2.129",
    transform: "translate(-413.511 57.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20880",
    "data-name": "Path 20880",
    d: "M73.5,373.237a3.76,3.76,0,0,1,3.13-4.726L96.986,365.1a14.107,14.107,0,0,0,10.666-7.392c1.541-3,1.5-6.349.852-9.649-3.871-20.366-25.5-48.321-49.653-63.445A124.234,124.234,0,0,0,13.92,267.471a122.632,122.632,0,0,0-90.757,20.013,119.039,119.039,0,0,0-30.207,30.062,113.84,113.84,0,0,0-7.758,12.893c-11.105,21.593-14.358,45.114-9.41,68.023,5.535,25.548,20.328,49.219,41.729,66.686,22.3,18.212,49.777,27.818,77.378,27.052a91.161,91.161,0,0,0,13.792-1.4c11.82-2.129,22.082-6.574,30.394-13.055h0c50.854-34.737,38.944-89.381,34.427-104.489",
    transform: "translate(163.425 28.436)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20881",
    "data-name": "Path 20881",
    d: "M194.455,412.8h28.508c.149-5.65,4.467-10.935,7.8-14.2H185.138c4.318,3.181,9.542,8.278,9.317,14.2m30.449,3.666H192.3a1.806,1.806,0,0,1-1.456-.732,1.827,1.827,0,0,1-.294-1.61c1.9-6.634-8.448-13.6-12.6-15.717a1.835,1.835,0,0,1,.826-3.47h56.888a1.835,1.835,0,0,1,1.073,3.317c-3.16,2.325-11.126,9.742-10.045,16.066a1.827,1.827,0,0,1-1.8,2.129",
    transform: "translate(-10.795 -45.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20882",
    "data-name": "Path 20882",
    d: "M239.635,155.5a4.663,4.663,0,1,0,4.633,4.663,4.663,4.663,0,0,0-4.633-4.663m0,12.991a8.34,8.34,0,1,1,0,.021",
    transform: "translate(-41.976 93.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20883",
    "data-name": "Path 20883",
    d: "M240.238,103.918h-.145a1.827,1.827,0,0,0-1.465.881,2.061,2.061,0,0,0-.153,1.886c.2.468.4.933.6,1.392.4.907.8,1.839,1.179,2.789.383-.988.8-1.954,1.205-2.891.187-.426.37-.852.554-1.277a2.057,2.057,0,0,0-.158-1.878,1.831,1.831,0,0,0-1.465-.886h-.158m-6.089,26.519a1.8,1.8,0,0,1-.762-.166,1.839,1.839,0,0,1-.894-2.436l5.761-12.57-1.277-2.785c-.379-.971-.792-1.916-1.231-2.917-.209-.477-.426-.95-.617-1.426a5.748,5.748,0,0,1,.4-5.263,5.425,5.425,0,0,1,4.352-2.614,7.009,7.009,0,0,1,.732,0,5.433,5.433,0,0,1,4.343,2.6,5.748,5.748,0,0,1,.426,5.237c-.187.426-.379.886-.571,1.329-.426,1-.852,1.933-1.205,2.9l-.047.111-1.277,2.8,5.736,12.408a1.844,1.844,0,0,1-.886,2.436,1.818,1.818,0,0,1-2.423-.89l-4.437-9.585-4.471,9.742a1.814,1.814,0,0,1-1.656,1.065",
    transform: "translate(-42.587 123.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20884",
    "data-name": "Path 20884",
    d: "M209.752,484.067a13.1,13.1,0,0,0-4.382.813c-3.709,1.324-5.859,6.438-5.229,12.446.639,6.106,3.977,12.093,9.393,16.862.328.29.664.571,1,.852a28.559,28.559,0,0,0,9.329-19.161,10.846,10.846,0,0,0-5.676-10.794,9.836,9.836,0,0,0-4.441-1.018m28.912,45.468h-.238c-11.331-1.495-20.66-4.795-27.805-9.828a43.038,43.038,0,0,1-9.146,5.276,59.455,59.455,0,0,1-19.417,4.565,1.835,1.835,0,0,1-.123-3.666,56.857,56.857,0,0,0,18.208-4.313,40.219,40.219,0,0,0,7.494-4.177l-.494-.426c-6.11-5.378-9.883-12.212-10.62-19.238-.8-7.7,2.333-14.4,7.639-16.287a14.067,14.067,0,0,1,19.349,14.822,32.383,32.383,0,0,1-10,20.984c6.557,4.386,15.074,7.29,25.4,8.648a1.835,1.835,0,0,1-.238,3.653",
    transform: "translate(-12.671 -94.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20885",
    "data-name": "Path 20885",
    d: "M151.375,357.054a1.81,1.81,0,0,1-.911-.247,1.844,1.844,0,0,1-.664-2.508c.106-.183,10.569-18.463,20.315-48.7,9.01-27.878,19.191-71.923,16.751-123.425a1.824,1.824,0,0,1,3.645-.17,346.227,346.227,0,0,1-3.832,69.743,362.745,362.745,0,0,1-13.115,55.1c-9.87,30.573-20.49,49.113-20.6,49.3a1.823,1.823,0,0,1-1.58.911",
    transform: "translate(4.939 77.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20886",
    "data-name": "Path 20886",
    d: "M294.725,356.419a1.831,1.831,0,0,1-1.58-.911c-.106-.187-10.76-18.787-20.639-49.449a362.011,362.011,0,0,1-13.123-55.24,346.14,346.14,0,0,1-3.777-69.926,1.823,1.823,0,0,1,3.641.179c-2.5,51.672,7.72,95.875,16.743,123.859,9.759,30.292,20.217,48.542,20.324,48.734a1.831,1.831,0,0,1-1.575,2.755",
    transform: "translate(-55.733 78.109)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20887",
    "data-name": "Path 20887",
    d: "M850.977,419.86l19.8,21.9,1.558,53.413L836.32,463.2l-4.99-21.448Z",
    transform: "translate(-599.802 -485.13)",
    fill: "#e5dbff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14496",
    "data-name": "Group 14496",
    transform: "translate(-213.27 -425.03)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20888",
    "data-name": "Path 20888",
    d: "M843.365,414.77c0,.375-5.365,89.517-5.365,89.517l35.342.37",
    transform: "translate(-390.361 -57.177)",
    fill: "#e5dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20889",
    "data-name": "Path 20889",
    d: "M251.19,547.8c.426,0,29.628-31.961,29.628-31.961l15.593,33.911-39.766,3.9Z",
    transform: "translate(-53.42 -115.211)",
    fill: "#ffc200"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2750",
    "data-name": "Rectangle 2750",
    width: 19.489,
    height: 17.931,
    transform: "translate(258.908 4.529)",
    fill: "#e5dbff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14497",
    "data-name": "Group 14497",
    transform: "translate(-213.27 -425.03)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20890",
    "data-name": "Path 20890",
    d: "M923.722,493.5H881.141a1.848,1.848,0,1,1,0-3.692h33.566l-71.187-70.22-18.31,18.071a1.9,1.9,0,0,1-2.649,0,1.831,1.831,0,0,1,0-2.61l20.967-20.686Z",
    transform: "translate(-381.184 -56.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20891",
    "data-name": "Path 20891",
    d: "M844.668,447.887a1.9,1.9,0,0,1-.664-.119,1.839,1.839,0,0,1-1.086-2.38L853.7,417.395a1.882,1.882,0,0,1,2.414-1.069,1.839,1.839,0,0,1,1.082,2.38L846.418,446.7a1.874,1.874,0,0,1-1.75,1.188",
    transform: "translate(-393.117 -58.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20892",
    "data-name": "Path 20892",
    d: "M743.632,439.482H646.625a1.848,1.848,0,1,1,0-3.692h87.9L620.472,324.625l-42.64,41.729a1.891,1.891,0,0,1-2.648,0,1.831,1.831,0,0,1,0-2.61l45.285-44.314Z",
    transform: "translate(-239.14 -2.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20893",
    "data-name": "Path 20893",
    d: "M618.691,386.5a1.856,1.856,0,0,1-1.724-2.555l26-61.619a1.878,1.878,0,0,1,2.444-1,1.84,1.84,0,0,1,1.009,2.414l-26,61.619a1.869,1.869,0,0,1-1.729,1.137",
    transform: "translate(-263.367 -3.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20894",
    "data-name": "Path 20894",
    d: "M520.314,452.739H488.868a1.848,1.848,0,1,1,0-3.692h31.446a1.848,1.848,0,1,1,0,3.692",
    transform: "translate(-188.781 -76.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20895",
    "data-name": "Path 20895",
    d: "M483.151,419.849h-20.5a1.848,1.848,0,1,1,0-3.692h20.5a1.848,1.848,0,1,1,0,3.692",
    transform: "translate(-173.725 -57.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20896",
    "data-name": "Path 20896",
    d: "M694.421,430.249H664.679a1.848,1.848,0,1,1,0-3.692h29.743a1.848,1.848,0,1,1,0,3.692",
    transform: "translate(-289.73 -63.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20897",
    "data-name": "Path 20897",
    d: "M772.466,485.629H741.089a1.848,1.848,0,1,1,0-3.692h31.378a1.848,1.848,0,1,1,0,3.692",
    transform: "translate(-333.604 -95.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20898",
    "data-name": "Path 20898",
    d: "M848.287,562.519H818.548a1.848,1.848,0,1,1,0-3.692h29.738a1.848,1.848,0,1,1,0,3.692",
    transform: "translate(-378.08 -139.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20899",
    "data-name": "Path 20899",
    d: "M957.373,554.139H935.708a1.848,1.848,0,1,1,0-3.692h21.665a1.848,1.848,0,1,1,0,3.692",
    transform: "translate(-445.353 -135.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20900",
    "data-name": "Path 20900",
    d: "M931.89,527.126H917.838a1.848,1.848,0,0,1,0-3.7H931.89a1.848,1.848,0,0,1,0,3.7",
    transform: "translate(-435.143 -119.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20901",
    "data-name": "Path 20901",
    d: "M903.582,499.179H893.128a1.848,1.848,0,1,1,0-3.692h10.454a1.848,1.848,0,1,1,0,3.692",
    transform: "translate(-420.904 -103.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20902",
    "data-name": "Path 20902",
    d: "M346.574,445.916a1.916,1.916,0,0,1-.877-.213,1.839,1.839,0,0,1-.771-2.5l60.226-111.587a1.878,1.878,0,0,1,2.529-.762,1.835,1.835,0,0,1,.775,2.5L348.239,444.941a1.886,1.886,0,0,1-1.656.975",
    transform: "translate(-107.117 -8.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20903",
    "data-name": "Path 20903",
    d: "M364.719,395.574a14.507,14.507,0,0,0-4.812.877c-3.9,1.363-6.293,6.638-5.8,12.825s3.662,12.4,8.942,17.458q1.214,1.154,2.555,2.231a30.622,30.622,0,0,0,10.292-20.971,11.386,11.386,0,0,0-5.961-11.16,11.071,11.071,0,0,0-5.2-1.277m4.13,35.768c6.076,3.986,13.724,6.843,22.832,8.516a47.046,47.046,0,0,0,8.58.779h50.569L347.764,333.959,250.79,440.654h83.382a63.5,63.5,0,0,0,20.081-4.684,44.58,44.58,0,0,0,8.141-4.471q-1.111-.933-2.129-1.916c-5.961-5.74-9.581-12.842-10.143-20.013-.639-8.09,2.763-14.869,8.461-16.862,4.8-1.678,9.257-1.461,13.243.634a15.329,15.329,0,0,1,8.026,15.005,34.686,34.686,0,0,1-11.02,22.994m91.348,13.264h-59.92a51.373,51.373,0,0,1-9.328-.853c-10.11-1.868-18.575-5.147-25.26-9.762a47.315,47.315,0,0,1-9.938,5.646,66.294,66.294,0,0,1-21.444,4.973H241.81L347.674,328.13Z",
    transform: "translate(-48.034 -7.429)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2752",
    "data-name": "Rectangle 2752",
    width: 27.443,
    height: 30.015,
    transform: "translate(311.291 -13.879)",
    fill: "#ff2b4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2753",
    "data-name": "Rectangle 2753",
    width: 3.998,
    height: 114.512,
    transform: "translate(310.954 -61.088)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2754",
    "data-name": "Rectangle 2754",
    width: 3.998,
    height: 114.512,
    transform: "translate(353.271 -61.088)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14498",
    "data-name": "Group 14498",
    transform: "translate(-213.27 -425.03)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20904",
    "data-name": "Path 20904",
    d: "M1053.674,436.421a2.04,2.04,0,0,1-2-2.078V419.487a2,2,0,1,1,4,0v14.856a2.044,2.044,0,0,1-2,2.078",
    transform: "translate(-513.052 -58.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20905",
    "data-name": "Path 20905",
    d: "M1053.674,554.589a2.04,2.04,0,0,1-2-2.082v-29.33a2,2,0,1,1,4,0V552.49a2.044,2.044,0,0,1-2,2.082",
    transform: "translate(-513.052 -118.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20906",
    "data-name": "Path 20906",
    d: "M1086.8,434.635a2.044,2.044,0,0,1-2-2.082V417.7a2,2,0,1,1,4,0v14.856a2.04,2.04,0,0,1-2,2.082",
    transform: "translate(-532.069 -57.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20907",
    "data-name": "Path 20907",
    d: "M1086.8,553.673a2.04,2.04,0,0,1-2-2.078V522.027a2,2,0,1,1,4,0v29.568a2.035,2.035,0,0,1-2,2.078",
    transform: "translate(-532.069 -117.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20908",
    "data-name": "Path 20908",
    d: "M1055.946,142.957a1.41,1.41,0,0,0-1.277.779,1.516,1.516,0,0,0,.047,1.524l.03.047,1.277,2.24,1.162-2.359a1.52,1.52,0,0,0,0-1.486,1.414,1.414,0,0,0-1.243-.745m8.861,28.061-8.516-14.9-7.281,14.771-3.555-1.9,8.427-17.092-2.555-4.454a5.85,5.85,0,0,1-.158-5.727,5.4,5.4,0,0,1,4.765-2.934,5.344,5.344,0,0,1,4.684,2.8,5.808,5.808,0,0,1,.072,5.591l-2.257,4.573,9.793,17.13Z",
    transform: "translate(-509.478 101.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20909",
    "data-name": "Path 20909",
    d: "M1034.275,281.62a11.53,11.53,0,0,0-4,.771c-3.406,1.252-5.5,6.323-4.995,12.05.49,5.557,3.321,11.7,9.334,16.811a27.83,27.83,0,0,0,8.882-18.791,10.069,10.069,0,0,0-4.922-9.73,8.711,8.711,0,0,0-4.3-1.111m-9.334-33.213a1.52,1.52,0,0,0-1.124.5L1010.8,263.387a1.613,1.613,0,0,0-.426,1.09l-.115,56.871c4.143-.464,13.392-2.078,21.1-7.507-6.459-5.778-9.525-12.727-10.083-19.034-.681-7.72,2.461-14.443,7.639-16.355a13.284,13.284,0,0,1,11.5.592,14.26,14.26,0,0,1,7.022,13.762c-.711,8.478-3.9,15.491-9.513,20.937,5.042,3.334,11.748,6.012,20.439,7.452V264.426a1.647,1.647,0,0,0-.375-1.043l-11.986-14.414a1.507,1.507,0,0,0-1.158-.549ZM1010.2,325.534a3.832,3.832,0,0,1-2.619-1.047,4.152,4.152,0,0,1-1.277-3.04l.111-56.956a5.876,5.876,0,0,1,1.49-3.926l13.017-14.477a5.433,5.433,0,0,1,4.041-1.827h19.924a5.438,5.438,0,0,1,4.181,1.989l11.982,14.409a5.885,5.885,0,0,1,1.35,3.768v56.9a4.143,4.143,0,0,1-1.371,3.1,3.832,3.832,0,0,1-3.164.928c-9.9-1.635-17.488-4.82-23.117-8.814a38.917,38.917,0,0,1-3.76,2.5,52.964,52.964,0,0,1-20.362,6.481,3.288,3.288,0,0,1-.426.026",
    transform: "translate(-486.998 40.729)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2756",
    "data-name": "Rectangle 2756",
    width: 51.987,
    height: 4.16,
    transform: "translate(308.118 -123.324)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14499",
    "data-name": "Group 14499",
    transform: "translate(-213.27 -425.03)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20910",
    "data-name": "Path 20910",
    d: "M1044.436,222.728h19.076V211.21a.226.226,0,0,0-.217-.23h-18.638a.226.226,0,0,0-.221.23Zm23.062,4.181h-27.068v-15.7a4.309,4.309,0,0,1,4.215-4.39h18.638a4.309,4.309,0,0,1,4.215,4.39Z",
    transform: "translate(-506.594 62.226)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutpostBackground);
export default __webpack_public_path__ + "static/media/outpost_background.1f55b16a0173fd3e0fad005b3071f28e.svg";
export { ForwardRef as ReactComponent };